import getGlobalThis from 'globalthis/polyfill';

// // https://mrjohnwiseman.com/blog/how_to_fix_referenceError_globalthis_is_not_defined
// For Outlook add-in running on legacy Edge
if (window.globalThis === undefined)
{
    (window as any).globalThis = getGlobalThis() ?? this;
}